import * as React from "react";
import { cs } from "../utils/utils-classname";

export class Button extends React.PureComponent<{
  icon?: string;
  onClick?: any;
  className?: string;
  tooltip?: string;
  title?: string;
  disabled?: boolean;
  loading?: boolean;
  children?: any;
  id?: string;
  style?: any;
  element?: "button" | "div";
  type?: "button" | "submit";
}> {
  render() {
    const {
      children,
      onClick,
      loading,
      disabled,
      icon,
      title,
      id,
      style,
      type,
    } = this.props;

    const classes = cs(this.props.className, {
      loading,
      disabled,
    });

    const BtnInside = (
      <>
        {icon && (
          <i className={icon.includes("pi-") ? icon : "iconf-" + icon}></i>
        )}
        {children ? <span>{icon ? " " + children : children}</span> : null}
      </>
    );

    return this.props.element === "div" ? (
      <div
        onClick={onClick}
        className={classes}
        style={style}
        id={id}
        title={title}
      >
        {BtnInside}
      </div>
    ) : (
      <button
        onClick={onClick}
        className={classes}
        style={style}
        disabled={disabled || loading}
        type={type ?? "button"}
        id={id}
        title={title}
      >
        {BtnInside}
      </button>
    );
  }
}
